module.exports = __webpack_public_path__ + "media/images/flags/TM-4f247d4521268c34f800e2e0cba65e70.svg";